import React, { useState, useRef } from 'react';
import ApiService from '../Service/ApiService';
import './Drawer.css';

const Drawer = ({ isOpen, onClose, isAlbanian }) => {
    const formRef = useRef(null);
    const [messageBox, setMessageBox] = useState({ visible: false, message: '' });
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        contactNumber: '',
        contactMessage: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await ApiService.createContact(formData);
            if (response.status === 200 || response.status === 201) {
              setMessageBox({ visible: true, message: "Form created successfully!" });
                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    contactNumber: '',
                    contactMessage: '',
                });
            } else {
              setMessageBox({ visible: true, message: "Something went wrong. Please try again." });
            }
        } catch (error) {
            console.error("Error creating project:", error);
            setMessageBox({ visible: true, message: "Error creating project. Please check the console for details." });
        }
    };

    const closeMessageBox = () => {
        setMessageBox({ visible: false, message: '' });
      };

    return (
        <div className={`drawer ${isOpen ? 'open' : ''}`}>
            <button className="drawer-close" onClick={onClose}>
                &times;
            </button>
            <div className="drawer-content">
                <h1 className="contact-title">{isAlbanian ? 'KONTAKT' : 'CONTACT US'}</h1>
                <div className="line-divider-belowcontact"></div>
                <div className='contact-column-form'>
                <div className="contact-double">
                    <div className="contact-description">
                        <p>{isAlbanian
    ? "Faleminderit për interesin tuaj. Nëse dëshironi të filloni punë, të bashkëpunoni me ne ose keni ndonjë pyetje, duam të dëgjojmë nga ju. Na shkruani dhe do ju kthejmë përgjigje. "
    : 'Thanks for your interest. Whether you are looking for a job, to work with us or just have a general question, we want to hear from you. Drop us a line, and we will get back to you.'}</p>
                    </div>
                    <div className="contact-double-column">
                        <div className="section headquarters">
                            <h2>{isAlbanian ? 'Zyrat' : 'Offices'}</h2>
                            <p>Vila-L sh.p.k.</p>
                            <p>Rruga "Sokrat Miho", Pallati Vila-L, Astir, Tiranë</p>
                            <p>+355682000187</p>
                            <p>info@vila-l.com</p>
                        </div>

                        <div className="line-divider"></div> 
                        
                        <div className="section additional-info">
                            <h2>{isAlbanian ? 'Doni të punoni me ne?' : 'Do you want to work with us?'}</h2>
                            <p onClick={() => window.location.href = "/listedjobs"} >
    <strong>{isAlbanian ? 'Nën kontraktor: ' : 'Sub contractors:'}</strong>
    {isAlbanian ? 'Ju lutemi kontrolloni pozicionet e lira' : 'Before reaching out, please review our job vacancies.'}
</p>
                            <li className="subcontractor-btn" onClick={() => formRef.current?.scrollIntoView({ behavior: 'smooth' })}>
                                {isAlbanian ? 'BASHKOHU ME NE →' : 'BECOME OUR PARTNER →'}</li>
                        </div>
                    </div>
                </div>
                <div className="contact-form" ref={formRef}>
                    <h3>{isAlbanian ? 'APLIKO' : 'APPLY'}</h3>
                    <div className='contact-form-first'>
                    <input 
                        type="text" 
                        name="firstName" 
                        placeholder={isAlbanian ? 'Emri' : 'Your name'} 
                        value={formData.firstName} 
                        onChange={handleInputChange} 
                    />
                    <input 
                        type="text" 
                        name="lastName" 
                        placeholder={isAlbanian ? 'Mbiemri' : 'Your surname'} 
                        value={formData.lastName} 
                        onChange={handleInputChange} 
                    />
                    </div>
                    <div div className='contact-form-first'>
                    <input 
                        type="email" 
                        name="email" 
                        placeholder={isAlbanian ? 'Emaili' : 'Your Email'} 
                        value={formData.email} 
                        onChange={handleInputChange} 
                    />
                    <input 
                        type="text" 
                        name="contactNumber" 
                        placeholder={isAlbanian ? 'Numri i telefonit' : 'Your phone number'} 
                        value={formData.contactNumber} 
                        onChange={handleInputChange} 
                    />
                    </div>
                    <label>{isAlbanian ? 'Mesazhi' : 'Your message'} </label>
                    <textarea 
                        name="contactMessage" 
                        value={formData.contactMessage} 
                        onChange={handleInputChange} 
                    />
                    <button type="submit" onClick={handleSubmit}>{isAlbanian ? 'DËRGO →' : 'SUBMIT →'}</button>
                </div>
                {messageBox.visible && (
        <div className="contact-application-message-box">
          <p>{messageBox.message}</p>
          <button onClick={closeMessageBox}>Close</button>
        </div>
      )}
                </div>
            </div>
        </div>
    );
};

export default Drawer;
